import { useState } from "react";
import PaymentForm from "../PaymentForm/PaymentForm.mjs";
import "./Payment.scss";
export default function Payment({}) {
  const [value, setValue] = useState("");
  const [mode, setMode] = useState(0);
  const fn = (value) => {
    if (value) {
      setMode(1);
    }
  };
  return mode == 0 ? (
    <div className="payment">
      <h2>Отправка оплаты</h2>
      <h2>Введите ЛС</h2>
      <input
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e?.keyCode === 13) {
            fn(value);
          }
        }}
      ></input>
      <button
        onClick={() => {
          fn(value);
        }}
      >
        OK
      </button>
    </div>
  ) : (
    <PaymentForm />
  );
}
